import { TFTSWeeklyState } from './types';

export function getTableData(state: TFTSWeeklyState) {
  return state.tableData;
}

export function getDeliveryTerms(state: TFTSWeeklyState) {
  return state.deliveryTerms;
}

export function getTransportTypes(state: TFTSWeeklyState) {
  return state.transportTypes;
}

export function getDeliveryGoodsPoints(state: TFTSWeeklyState) {
  return state.deliveryGoodsPoints;
}

export function getExporters(state: TFTSWeeklyState) {
  return state.exporters;
}
